export const GET_HISTORICAL_REQUEST = 'GET_HISTORICAL_REQUEST';
export const GET_HISTORICAL_SUCCESS = 'GET_HISTORICAL_SUCCESS';
export const GET_HISTORICAL_FAILURE = 'GET_HISTORICAL_FAILURE';

export const SET_HISTORICAL = 'SET_HISTORICAL';

export const getHistoricalRequest = (ticket_id, filters = {}, ticketType) => ({
    type: GET_HISTORICAL_REQUEST,
    payload: {
        ticket_id,
        filters,
        ticketType
    }
});

export const getHistoricalSuccess = (historical, statuses) => ({
    type: GET_HISTORICAL_SUCCESS,
    payload: {
        historical,
        statuses
    }
});

export const getHistoricalFailure = err => ({
    type: GET_HISTORICAL_FAILURE,
    error: err
});

export const setHistorical = (historical = []) => ({
    type: SET_HISTORICAL,
    payload: {
        historical
    }
});
